module.exports = "/assets/e21fd1208ed24c577a4d1dd7ed8b5cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/S4.png
// module id = 1808
// module chunks = 0